import { COMMON_ATTRIBUTES, COMMON_QUESTIONS, COMMON_VIEW_LABEL } from '../constants';

export const RETAINER_ATTRIBUTES = {
  ...COMMON_ATTRIBUTES,
  ARCH_TYPE: 'jaws_id',
  RETAINER_CUT_TYPE: 'retainer_cut_type',
  SCAN_SUBMISSION_METHOD: 'scan_submission_type',
  SCANNER: 'scanner_type',
  CUSTOM_SCANNER_NAME: 'custom_scanner_type_name',
  STL_FILES: 'stl_files',
  INTRAORAL_PHOTOS: 'rx_intraoral_photos'
};

export const RETAINER_ARCH_OPTIONS = [
  { value: 3, label: 'Both' },
  { value: 2, label: 'Mandibular Only' },
  { value: 1, label: 'Maxillary Only' }
];

export const RETAINER_ARCH_LABELS = RETAINER_ARCH_OPTIONS.reduce((labels, option) => {
  return { ...labels, [option.value]: option.label };
}, {});

export const RETAINER_CUT_TYPE_OPTIONS = [
  { id: 1, name: 'Straight Cut' },
  { id: 2, name: 'Scalloped Cut' }
];

export const RETAINER_CUT_TYPE_LABELS = RETAINER_CUT_TYPE_OPTIONS.reduce((labels, option) => {
  return { ...labels, [option.id]: option.name };
}, {});

export const RETAINER_QUESTIONS = {
  ...COMMON_QUESTIONS,
  [RETAINER_ATTRIBUTES.ARCH_TYPE]: 'Arch',
  [RETAINER_ATTRIBUTES.RETAINER_CUT_TYPE]: 'Cut',
  [RETAINER_ATTRIBUTES.SCAN_SUBMISSION_METHOD]: 'How will you be submitting your scans?'
};

export const RETAINER_VIEW_LABEL = {
  ...COMMON_VIEW_LABEL,
  [RETAINER_ATTRIBUTES.CASE_NUMBER_TEXT]: 'Case Number',
  [RETAINER_ATTRIBUTES.ARCH_TYPE]: 'Arch',
  [RETAINER_ATTRIBUTES.RETAINER_CUT_TYPE]: 'Cut',
  [RETAINER_ATTRIBUTES.SCAN_SUBMISSION_METHOD]: 'Upload Intraoral Scans.',
  [RETAINER_ATTRIBUTES.INTRAORAL_PHOTOS]: 'Upload intraoral photos.',
  [RETAINER_ATTRIBUTES.SHIPPING_LOCATION]: 'Shipping Location',
  [RETAINER_ATTRIBUTES.SHIPPING_METHOD]: 'Shipping Method',
  tracking_number: 'Tracking Number',
  [RETAINER_ATTRIBUTES.NOTES]: 'Special Instructions'
};
